import React from 'react';
import { jsx } from '@emotion/core';
import { facepaintMediaQueries } from '../shared';
import { GRID } from '../../constants';
var styles = facepaintMediaQueries({
  display: ['block', 'block', 'flex'],
  marginTop: [GRID.small, GRID.small, GRID.large],
  marginBottom: [GRID.xsmall, GRID.xsmall, GRID.small],
  justifyContent: 'space-between',
  flexWrap: 'wrap'
});
var stylesChild = facepaintMediaQueries({
  marginBottom: [GRID.xsmall, GRID.xsmall, 0],
  width: ['100%', '100%', "calc(50% - " + GRID.xsmall + ")"]
});
export var TwoColumns = function TwoColumns(_a) {
  var children = _a.children;
  return jsx("div", {
    css: styles
  }, React.Children.map(children, function (child) {
    return jsx("div", {
      css: stylesChild
    }, child);
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Grid/TwoColumns.js
// module id = 829
// module chunks = 0